// extracted by mini-css-extract-plugin
export default {"dataContainer":"analytics_dataContainer__UQvEy","numeriacalContainer":"analytics_numeriacalContainer__HLtlt","noDataContainer":"analytics_noDataContainer__Jh4FB"};